import dynamic from "next/dynamic"
import { Navbar, Footer } from "components/common"
import useStore from "components/ui/Context"
import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import cn from "classnames"
import * as Sentry from "@sentry/nextjs"

const ModalDownloadApp = dynamic(() => import("components/ModalDownloadApp"))

export default function Layout({ children, pageProps }) {
  const router = useRouter()
  const { togleModalLogin } = useStore()
  const isShort = router.pathname.startsWith("/short")
  const [isMobile, setIsMobile] = useState(false)
  const [system, setSystem] = useState("other")
  const redirectUrl = process.env.NEXT_PUBLIC_REDIRECT_ONPLUS
  const redirectValue = router.query[redirectUrl]

  function DowloadApp() {
    if (system === "android") {
      window.open("https://play.google.com/store/apps/details?id=com.vtvcab.onsports")
    } else if (system === "ios") {
      window.open("https://apps.apple.com/vn/app/on-sports/id1282845933#?platform=iphone")
    } else {
      window.open("https://play.google.com/store/apps/details?id=com.vtvcab.onsports")
    }
  }

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setSystem("ios")
    } else if (/android/i.test(userAgent)) {
      setSystem("android")
    } else {
      setSystem("other")
    }
  }, [])

  useEffect(() => {
    const isShortPage = window.location.pathname.includes("/short")
    if (isShortPage) {
      document.body.style.overflow = "hidden"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [])
  useEffect(() => {
    if (redirectValue) {
      togleModalLogin()
    }
  }, [redirectValue])

  return (
    <main>
      {/* <ModalDownloadApp /> */}
      <Navbar menus={pageProps?.menus || []} />
      <div className="m-auto container__screen flex flex-col min-h-screen">
        {/* <div className="h-16 w-full"></div> */}
        <div className={cn("w-full flex-grow", isShort ? "mt-0" : "mt-12")}>{children}</div>
        {!isShort && <Footer />}
      </div>
      {isMobile && !isShort && (
        <div className="flex justify-between bg-dark-500 fixed bottom-0 w-full z-[99] h-12 px-4 py-8 text-dark-100 text-xs items-center bg-opacity-100">
          <div className="flex justify-center items-center">
            <div className="w-8 h-8 mr-2">
              <img src="/logo/logo-wc.png" width={30} height={30} alt="xx" />
              {/* Logo thường: */}
              {/* <img src="/logo/logo.png" width={30} height={30} alt="xx" /> */}
            </div>
            Cài đặt ứng dụng ON Plus để trải nghiệm tốt hơn!
          </div>
          <button
            className="w-[100px] py-1 px-2 border bg-primary-500 rounded-lg ml-2 text-dark font-medium"
            onClick={DowloadApp}
          >
            Tải ngay
          </button>
        </div>
      )}
    </main>
  )
}

{
  /* <div className="flex md:block">
<div className="mb-3 mr-6 md:mr-0">
  <a
    href="https://apps.apple.com/vn/app/on-sports/id1282845933#?platform=iphone"
    target="_blank"
    rel="noreferrer"
  >
    <Image
      src="https://stvinaprod.vtvcab.vn/91af4b21-6541-4aac-b557-eedde81a0f0a.png"
      width={121}
      height={35}
    />
  </a>
</div>
<div>
  <div style={{ height: 35 }}>
    <a
      href="https://play.google.com/store/apps/details?id=com.vtvcab.onsports"
      target="_blank"
      rel="noreferrer"
    >
      <Image
        src="https://stvinaprod.vtvcab.vn/3c3bd6a8-bf15-48ab-9bcb-ec12ced5598e.png"
        width={121}
        height={35}
      />
    </a>
  </div>
</div>
</div> */
}
